(function() {
  // Hero scroll reveal + frost effect
  const heroContent = document.querySelector('.sc-hero__content');
  const heroFrost = document.querySelector('.sc-hero__frost');
  const heroSection = document.querySelector('.sc-hero');

  if (heroContent) {
    var frostStart = 80;

    function handleHeroScroll() {
      var scrollY = window.scrollY;

      if (scrollY > 80) {
        heroContent.classList.add('is-visible');
      } else {
        heroContent.classList.remove('is-visible');
      }

      // Frost effect: ramp from 0 to 1 between frostStart and section bottom
      if (heroFrost && heroSection) {
        var sectionHeight = heroSection.offsetHeight;
        var frostEnd = sectionHeight * 0.6;
        var progress = 0;
        if (scrollY > frostStart) {
          progress = Math.min((scrollY - frostStart) / (frostEnd - frostStart), 1);
        }
        heroFrost.style.setProperty('--frost-progress', progress);
      }
    }
    window.addEventListener('scroll', handleHeroScroll, { passive: true });
    handleHeroScroll();
  }

  // CTA scroll reveal — wait for DOM ready
  function initCTAObserver() {
    const ctaContent = document.querySelector('.sc-cta__content');
    const ctaOverlay = document.querySelector('.sc-cta__overlay');
    if (!ctaContent) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Text fades in immediately over 2s
          ctaContent.classList.add('is-visible');
          // Frost begins after 1s delay, transitions over 2s
          setTimeout(() => {
            if (ctaOverlay) ctaOverlay.classList.add('is-frosted');
          }, 1000);
          observer.unobserve(ctaContent);
        }
      });
    }, { threshold: 0.15 });

    observer.observe(ctaContent);

    // Fallback if already in viewport on load
    const rect = ctaContent.getBoundingClientRect();
    if (rect.top < window.innerHeight) {
      ctaContent.classList.add('is-visible');
      setTimeout(() => {
        if (ctaOverlay) ctaOverlay.classList.add('is-frosted');
      }, 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCTAObserver);
  } else {
    initCTAObserver();
  }
})();
